import angular from "angular";
import PayPalCard from "./PayPalCard.vue";
import Vue from "vue";
import "ngVue";

export default angular
  .module("directives.paypalcard", [])
  .directive("dcPaypalCard", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcPaypalCard", PayPalCard));
    },
  ]);

